export default __webpack_public_path__ + "static/demand360-product-e595ab78cc96e9ffc787fdc85a661461.png";